export default "__VITE_ASSET__1f356319__"